<template>
  <div id="app" v-if="ifAjaxComplete">
    <div class="share-show-wrap" v-if="!isClient">
        <div class="guide-box flex-wrapper">
          <img src="./assets/logo.png" alt="">
          <span class="flex-wrapper" @click="jumpApp()">立即打开</span>
        </div>
      </div>
    <div class="detail-wrap" v-if="detailsData">

      
      
      <div class="content-wrap" style="padding:5px 15px 20px;">
        <div v-if="!isClient">
          <p class="title">{{ detailsData.title }}</p>
          <p class="source flex-wrapper"><img :src="detailsData.avatar || 'https://a.cfbond.com/cfbond/logo.png'" alt="" v-if="detailsData.avatar">{{ detailsData.source }} {{detailsData.author ? '·'+detailsData.author : ''}} <span>{{ detailsData.published_time }}</span></p>
        </div>
        <div v-html="Utils.delWxfmt(detailsData.content)" class="content" :class="{'hide-content': ifSpHideAll}" v-if="detailsData.category !== 3"></div>

        <div class="content iframe-content" :class="{'hide-content': ifSpHideAll}" v-else>
          <div class="file-preview-wrap" v-if="detailsData.file_type === 1">
            <div v-if="numPages">
              <pdf v-for="i in numPages"
              :key="i"
              :src="pdfPath"
              :page="i"></pdf>
            </div>
          </div>
          <div class="file-preview-wrap" v-else>
            <div class="iframe-wrap">
              <iframe width="100%" :src="officeFileUrl" frameborder="0"></iframe>
            </div>
          </div>
        </div>

        <div v-if="!$isClient" class="sp-handle-box">
          <p class="login-tips" @click="ifSpHideAll = !ifSpHideAll" v-if="ifSpHideAll">
            {{ ifSpHideAll ? '展开' : '收起'}}全文
            <img src="./assets/arrow.png" :class="{'reversed': !ifSpHideAll}"/>
          </p>
          <div class="login-button flex-wrapper" @click="jumpApp()">
            <span>打开中国财富客户端  阅读全文</span>
          </div>
        </div>
        
      </div>

      <a class="ad-wrap" href="javascript:void(0)" v-if="adImg" @click="openNewWindow(adUrl)">
        <span v-if="newsTag">{{ newsTag }}</span>
        <img :src="adImg" alt="">
      </a>
    </div>
    <div class="blank-wrap" v-else>
      <img src="./assets/non-exist.png" alt="">
      <p>该文章已不存在</p>
    </div>
    
    <!-- <div class="comment-list-wrap">
      <p class="comment-head">
        评论 ({{commentCount}})
      </p>

      <div class="comment-list">
        <div class="comment-cell flex-wrapper" v-for="(item,ind) in commentList" :key="ind">
          <div class="avatar-wrap">
            <img :src="item.avatar" alt="">
          </div>
          <div class="right-wrap">
            <p class="comment-nickname">{{ item.nickname}}</p>
            <p class="comment-content">
              {{ item.comment}}
            </p>
            <p class="flex-wrapper comment-other">
              <span class="comment-time">{{ item.create_time}}</span>
              <span class="comment-like flex-wrapper" @click="LikeIt(comment_id)">
                <font>{{ item.like_count }}</font>
                <img src="./assets/thumbs_blue.png" alt="">
              </span>
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import UTILS from '../../common/utils'

export default {
  components: {
    pdf
  },
  name: 'app',
  data(){
    return{
      detailsData:{

      },
      commentList:[],
      commentCount:0,
      isClient: this.$isClient,
      detailUrl: '',
      adImg:'',
      adUrl:'',
      newsTag:'',
      currentPage: 0,
      pageCount: 0,
      pdfPath:'',
      numPages:undefined,
      officeFileUrl:'',
      ifAjaxComplete:false,
      ifSpHideAll: true
    }
  },
  mounted() {
    this.getDetail()
    this.getAd()
    this.ifSpHideAll = !this.$isClient
  },
  methods:{
    openNewWindow(_url){
      if(_url) {
        window.open(_url)
      }
    },
    // LikeIt(_id){
    //   this.$axios.post('/wealth/account_fav',{
    //     id:_id
    //   }).then(res => {
    //     console.log(res)
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    getDetail(){
      this.$axios.get('/wealth/account_news_detail?news_id='+this.newsId).then(res => {
        if(res.data.code === 0) {
          this.detailsData = res.data.data
          this.commentList = res.data.data.data_list
          this.commentCount = res.data.data.comment_count
          this.detailUrl = res.data.data.detail_url
          window.document.title = this.detailsData.title || '中国财富-财富号详情'
          UTILS.loadTRStat(this.detailsData.id, this.detailsData.published_time, this.detailsData.author, this.detailsData.source)
          if (res.data.data.category === 3) {
            if(res.data.data.file_type===1) {
              this.pdfPath = pdf.createLoadingTask(res.data.data.detail_url)
              // this.pdfPath = pdf.createLoadingTask('./173000003524528459.pdf')
              this.pdfPath.promise.then(pdf => {
                this.numPages = pdf.numPages
              }).catch(err=>{
                console.log(err);
              })
            } else {
              this.officeFileUrl = 'https://view.officeapps.live.com/op/embed.aspx?src='+encodeURIComponent(res.data.data.detail_url)
            }
          }
          let shareTitle = this.detailsData.title || '中国财富资讯'
          // let shareImg = this.detailsData.image_list[0] || "https://a.cfbond.com/cfbond/logo.png"
          let shareImg = process.env.VUE_APP_SHARE_ICON_COMMON
          try{
            window.wx.ready(function(){
              window.wx.updateAppMessageShareData({
                title: shareTitle, // 分享标题
                desc: "来自中国财富传媒集团",
                link: location.href, // 分享链接
                imgUrl: shareImg, // 分享图标
                success: function () {
                  // alert("成功");
                },
                cancel: function () {
                  // alert("失败")
                }
              })
              window.wx.updateTimelineShareData({
                title: shareTitle, // 分享标题
                link: location.href, // 分享链接
                imgUrl: shareImg, // 分享图标
                success: function () {
                  // alert("成功");
                },
                cancel: function () {
                  // alert("失败")
                }
              })
            })
            window.wx.error(function(err){
              // alert(err)
            })
          } catch(err){
            console.log(err)
          }
        } else {
            this.detailsData = ''
          }
        this.ifAjaxComplete = true
      }).catch(err => {
        console.log(err)
        this.ifAjaxComplete = true
      });
    },
    getAd(){
      this.$axios.get('/wealth/detail_ad?news_id='+this.newsId).then(res => {
        if (res.data.code === 0) {
          this.adImg = res.data.data.image;
          this.adUrl = res.data.data.detail_url || ''
          this.newsTag = UTILS.NEWS_TEXT[res.data.data.news_tag] || ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    changePdfPage (val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
        // console.log(this.currentPage)
      }
    },
    // pdf加载时
    loadPdfHandler () {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    jumpApp(){
      // this.Utils.fixJump({id:this.newsId,mode:4});
      // this.Utils.fixJump({id:this.newsId,mode:1});
      var _id = this.newsId
      var _ori = window.location.origin
      var _url=_ori+'/cfbond/detail/AccountDetail.html?news_id='+_id
      var urlParam = 'cfbond://com.cfbond.acfw/applinks?id='+_id+'&mode=4&url='+_url
      if(navigator.userAgent.match(/android/gi)){
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&android_schema='+encodeURIComponent(urlParam)
      } else {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&ios_schema='+encodeURIComponent(urlParam)
      }
      // if(navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)){
      //   window.location.href='https://apps.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E8%B4%A2%E5%AF%8C/id1370729250'
      // } else {
      //   window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.cfw'
      // }
    }
  }
}
</script>

<style scoped>
  @import '../../common/style.css';
 
  .detail-wrap{
    
    background-color:#fff;
    width:100%;
    overflow:hidden;
  }
  .title{
    font-size:22px;
    color:#222;
    line-height: 31px;
    font-weight: bold;
  }
  .source{
    font-size:14px;
    color:#999;
    line-height:20px;
    margin-top:15px;
    align-items: center;
  }
  .source span{
    margin-left:10px;
  }
  .source img{
    width:24px;
    height: 24px;
    margin-right:2px;
  }
  
  .recommend-list-wrap{
    margin-top:60px;
  }
  .recommend-head{
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color:#333;
  }
  .recommend-head span{
    flex:1;
    height: 1px;
    background: #f1eded;
    margin:0 15px;
  }

  .author{
    color:#888;
    font-size:18px;
    line-height: 32px;
  }
  .comment-cell{
    margin-bottom:15px;
  }
  .comment-list-wrap{
    padding:15px 14px;
    background-color:#fff;
    margin-top:10px;
  }
  .comment-head{
    margin-bottom:20px;
  }
  .avatar-wrap{
    margin-right: 10px;
  }
  .avatar-wrap img{
    width:35px;
    height:35px;
    border-radius: 100%;
  }
  .comment-nickname{
    line-height: 35px;
    font-size:14px;
    color:#666666;
  }
  .comment-content{
    margin-top:5px;
    color:#333;
    font-size:16px;
    line-height:27px;
  }
  .comment-other{
    justify-content: space-between;
    margin-top:11px;
  }
  .comment-time{
    font-size: 12px;
    color:#999;
    line-height: 16px;
  }
  .comment-like{
    align-items: center;
  }
  .comment-like font{
    font-size: 14px;
    color:#3078EE;
    margin-right: 5px;
    line-height: 16px;
  }
  .comment-like img{
    height:16px;
  }
  .right-wrap{
    border-bottom:1px solid #E8E8E8;
    padding-bottom:15px;
  }
  .guide-box{
    height:50px;
    background-color: #F9F9F9;
    align-items: center;
    padding:0 15px;
    justify-content: space-between;
  }
  .guide-box img{
    height:35px;
  }

  .guide-box span{
    align-items: center;
    justify-content: center;
    color:#fff;
    width:82px;
    height:31px;
    background-color:#3078EE;
    border-radius: 3px;
    font-size:14px;
  }
  .iframe-content{
    height:auto;
    margin-top:10px;
    text-align: center;
  }
  .iframe-content>div>span{
    width:100%;
  }
  .iframe-content iframe{
    display: block;
    height:100%;
  }
  .iframe-content iframe::-webkit-scrollbar{
    display:none;
  }
  .pdf-pagination{
    text-align: center;
    margin:10px auto;
    font-size:13px;
    color:#2c2c3c;
  }
  .iframe-wrap{
    height:500px;
  }
  .iframe-wrap iframe{
    height:100%;
  }
  .blank-wrap{
    text-align: center;
  }
  .blank-wrap img{
    width:120px;
    margin-top:120px;
    margin-left:3px;
  }
  .blank-wrap p{
    color:#999999;
    font-size:14px;
    margin-top:20px;
  }
  .hide-content{
    max-height:300px;
    overflow:hidden;
    position: relative;
  }
  .hide-content:after{
    content:'';
    position: absolute;
    width:100%;
    height:200px;
    bottom:-1px;
    left:0;
    background:linear-gradient(rgba(255,255,255,0),rgba(255,255,255,.7),rgba(255,255,255,1));
  }
  .sp-handle-box .login-tips{
    text-align: center;
    font-size:14px;
    color:#3078EE;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .sp-handle-box .login-tips img{
    height:18px;
  }
  .sp-handle-box .login-tips img.reversed{
    transform: rotate(180deg)
  }
  .sp-handle-box .login-button{
    justify-content: center;
    width:270px;
    margin:30px auto 0;
    align-items: center;
    background-color:#3078EE;
    height:44px;
    color:#fff;
    font-size:18px;
    border-radius: 3px;
  }
</style>
<style>
  .content p{
    font-size:18px;
    line-height: 32px;
    margin-bottom:15px;
    text-indent:0!important;
  }
  .content img,.content p img,.content video{
    width:100%!important;
  }
  content img,.content p img{
    height:auto!important;
  }
</style>
